// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"b5aa54f3","372":"7117d429","547":"7d356c9c","570":"3cd541c6","788":"8bb30461","882":"34848e53","966":"ff1b57a1","991":"8a6b11e9"}[chunkId] + ".chunk.css";
};